import React from "react";
import { Grid } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import FacultyCard from "../../muiCommonComponent/facultyCards";

const FacultyList=()=>{
    const facultyList=[
      {img:'/assets/img/SBMC/anjali_gupta.png',name:'Ms. Anjali Gupta',position:'Assistant Professor',email:'anjaligupta.sbmc@mvn.edu.in', gs: "https://scholar.google.com/citations?view_op=list_works&hl=en&authuser=1&user=o-409_sAAAAJ",
        linkedin: "www.linkedin.com/in/anjali-gupta-89b982303",
        orcid: "https://orcid.org/0009-0002-8027-8362",
        rg: "https://www.researchgate.net/profile/Anjali-Gupta-93",
        website: "#",
        aoi: " Finance",
        education: "B.COM, MBA(Finance), PHD (Finance) Pursuing",
        re: "3",
        te: "6.5",
        iece: "N/A",
        articles:
          "<li>1. Gupta, A., & Singh, N. P. (2024). De-Merger and Its Effect on Performance: A Case Study of Piramal Enterprise Limited. Trends in Economics, Finance and Management Journal, 6(2), 53-80. https://doi. org//10.69648/RVPL2804</li>",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "1. Accounts Computer Course, HARTRON (Haryana State Electronics Development Corporation), Haryana.",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},

        {img:'/assets/img/SBMC/anuj_tiwari.png',name:'Ms. Anju Tiwari',position:'Assistant Professor',email:'anju.tiwari@mvn.edu.in', gs: "#",
        linkedin: "www.linkedin.com/in/anju-tiwari-98091b227",
        orcid: "https://orcid.org/0009-0008-9000-8108",
        rg: "www.researchgate.net/profile/Anju-Tiwari",
        website: "#",
        aoi: "Marketing, Human Resource Management ",
        education: "PhD - Business Administration  ( Pursuing)",
        re: "1.5",
        te: "1. 6",
        iece: "N/A",
        articles:
          "N/A",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "1. National Eligibility Test (N.E.T.) by Union Grant Commission (UGC) India, Dec-2022 with a percentile of 99.645.",
        aa2: "2. National Eligibility Test (N.E.T.), by Union Grant Commission (UGC) India, june-2023 with a percentile of 99.467",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},

        {img:'/assets/img/SBMC/aradhana_sorout.png',name:'Ms. Aradhana Sorout',position:'Assistant Professor',email:'Aradhana.sorout@mvn.edu.in', gs: "https://scholar.google.com/citations?view_op=new_profile&hl=en",
        linkedin: "https://www.linkedin.com/in/aradhana-sorout-9913b1241/",
        orcid: "https://orcid.org/0000-0003-2022-6392",
        rg: "https://www.researchgate.net/profile/Aradhana-Sorout",
        website: "#",
        aoi: "Finance",
        education: "B.com(H), M.com, UGC NET, PhD-Behavioral Finance (Pursuing)",
        re: "4",
        te: "5",
        iece: "N/A",
        articles:
          "1. Singh, N. P., & Sorout, A. (2022). An Exploratory Analysis of Cost of Covid-19 Vaccines in India. Industrija, 50(3/4), 7-35.",
        books:
          "N/A",
        chapters:
          "1. Sorout, A., Singh, N. P., & Pathak, A. A. (2025). Behavioral Finance and Sustainability: unveiling risk biases in investment decisions. In Sustainability in emerging economies-Integrating business excellence in management education (SEE-IBEME-2024) (pp. 169-179). Atlantis Press-Springer Nature.",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "1. Sorout, A. & Singh, N. P. (2025). Emerging Frontiers in AI and Knowledge Management: Visualising trends using bibliometric analysis, Business Information Review, 42(4), 214-225. https://doi.org/10.1177/02663821251387054",
        aa2: "2. Sorout, A. & Singh, N. P. (2025). Bankruptcy prediction using the Altman Z- Score modification model in India: A case study of Bharti Airtel limited. Southeast Asian Business Review, 3(1), 12–33. https://doi.org/10.20473/sabr.v3i1.63958",
        aa3: "3. Chaired a session on “Artificial Intelligence, Sustainability and Green Technology” as a track chairperson in MVN University’s 4th International conference on Campus to Corporate – Industry 5.0: A multidisciplinary conference bridging Technology, Humanity & Healthcare'' (November, 2025).",
        aa4: "4. Conducted a Faculty Development Program (FDP) on Quantitative Research Methods (July, 2025) organized by MVN University.",
        aa5: "",
        aa6: "",},

         {img:'/assets/img/SBMC/bharti_chaudhary.png',name:'Ms. Bharti Chaudhary',position:'Assistant Professor',email:'bharti.sbmc@mvn.edu.in', gs: "https://scholar.google.com/citations?user=QBHTLyYAAAAJ&hl=en",
        linkedin: "www.linkedin.com/in/bharti-chaudhary-tewatia-574182268",
        orcid: "https://orcid.org/0009-0002-4193-4646",
        rg: "https://www.researchgate.net/profile/Bharti-Chaudhary-6",
        website: "#",
        aoi: "Management ",
        education: "B.COM(H) M.COM and PhD, Management (Pursuing)",
        re: "3",
        te: "4",
        iece: "N/A",
        articles:
          "<li>1. Bharti Chaudhary, N. P. Singh, Ruby Mittal “Review of literature on capital structure: Independent and Dependent Variables”</li>",
        books:
          "N/A",
        chapters:
          "1.  Bharti Chaudhary, N. P. Singh Key determinants of venture capital investment performance: Insights for informed decisions.",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "1.Course on Computer Concepts (CCC) from Government of India: National Institute of Electronics & Information Technology. (NIELIT)",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},

        {img:'/assets/img/SBMC/np_singh.png',name:'Dr. N. P. Singh',position:'Pro-Vice Chancellor',email:'pvc@mvn.edu.in & dr.npsingh@mcn.edu.in',gs: "https://scholar.google.com/citations?user=cUgmsSMAAAAJ&hl=en",
        linkedin: "https://www.linkedin.com/in/netra-pal-singh-a6a6253/",
        orcid: "https://orcid.org/0000-0002-3006-9522",
        rg: "https://www.researchgate.net/profile/Netra-Singh",
        website: "#",
        aoi: "IT Management/ Machine Learning/AI",
        education: "PhD (Statistics)",
        re: "42",
        te: "42",
        iece: "N/A",
        articles:
          "<li>1. Singh, N. P. (2007). Consumer Perception about fast food in India, (with Anita Goyal). British Food Journal, Vol.109 (2): 182-195 (Citations -462: IF 4.09).</li>          "
          ,
        books:
          "N/A",
        chapters:
          "1. Gupta, Nakul and Singh N.P. (2019). When Artificial Intelligence Meets Augmented Reality Management and Business Education in the Time of Artificial Intelligence, pages 195–210. Copyright © 2019 by Information Age Publishing (Book Edited by Dr. Agata and Dr. Wolfgang).",
        patents:
          "N/A",
        membership:
          "<li>1. Life Member of Indian Science Congress Association</li><li>2. Life Member of Indian Society of Agricultural Statistics</li>",
        aa1: "1. University Scholarship by Haryana Agricultural University during Ph.D. 1977.",
        aa2: "2. Council of Scientific & Industrial Research (CSIR): Junior Research Fellowship 1978- 1981        ",
        aa3: "3. Young Scientist Award by Indian Scoiety of Agricultural Research 1989",
        aa4: "",
        aa5: "",
        aa6: "",},

        {img:'/assets/img/SBMC/ruby_mittal.png',name:'Dr. Ruby Mittal',position:'Assistant Professor',email:'ruby.mittal@mvn.edu.in, mittalruby888@gmail.com ', gs: "1. https://scholar.google.com/citations?view_op=new_profile&hl=en&imq=Ruby+Mittal ",
        linkedin: "www.linkedin.com/in/ruby-mittal-16a612241",
        orcid: "https://orcid.org/my-orcid?orcid=0009-0007-7881-3692",
        rg: "www.researchgate.net/profile/Ruby-Mittal",
        website: "#",
        aoi: "Finance, Human Resource, Entrepreneurship",
        education: "PhD (Management)",
        re: "7",
        te: "10+",
        iece: "0.5",
        articles:
          "<li>1. Mittal, R. and Kumar, Sadana, S. (2020). A Study on Working Capital Management Efficiency of TCS (India’s Top 1 Company), Wesleyan Journal of Research.</li><li>2. Ruby Mittal, Rajnish Kumar and Netra Pal Singh, “Evaluating the impact of Digitalization on Agricultural Practices: A Review” by Plant Archives (An International Journal).   </li><li>3. Ruby Mittal and N.P Singh “ Bankruptcy prediction of software companies using Altman z –Score” Review of Finance and Banking.</li>",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "Qualified H –TET PGT EXAM 2016",
        aa2: "University Positions in B.B.A. 1st sem (10th rank) & in 3rd sem (14th rank) in M.D.U. ",
        aa3: "In M.B.A. 1st SEM (11th rank) In M.D.U.",
        aa4: "",
        aa5: "",
        aa6: "",},
        
        {img:'/assets/img/SBMC/manchanda.jpg',name:'Dr. S.C. Manchanda',position:'Professor (Management)',email:'prof.sc.manchanda@gmail.com',gs: "#",
        linkedin: "#",
        orcid: "#",
        rg: "#",
        website: "#",
        aoi: "Quantitative Techniques, Finance, HR",
        education:"PhD (Management)",
        re: "3",
        te: "17",
        iece: "35",
        articles:
          "N/A",
        books:
          "<li>1. Economics for Engineers</li><li>2. Security Analysis and Portfolio Management</li><li>3. Operation Research and Business Statistics – Under Publishing</li>",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "N/A",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},

        {img:'/assets/img/SBMC/saraswati.png',name:'Dr. Saraswati',position:'Assistant Professor',email:'saraswati.sbmc@mvn.edu.in', gs: "https://scholar.google.com/citations?view_op=new_articles&hl=en&imq=Dr.+Saraswati+.#",
        linkedin: "https://www.linkedin.com/in/saraswati-7800782a6/",
        orcid: "https://orcid.org/0000-0003-3729-4519",
        rg: "https://www.researchgate.net/profile/Saraswati-Tewatia",
        website: "#",
        aoi: "Finance, HRM",
        education: "PhD (Financial management)",
        re: "7",
        te: "2.5",
        iece: "N/A",
        articles:
          "<li>1. Saraswati and Netra Pal Singh, “A Study of E-Banking Services in Public Sector Banks in India,” KINERJA Volume 28, No. 1, 2024 Page. 1-22, doi: 10.14569/IJACSA.2022.0130115.</li><li>2. Saraswati, “Use of Plastic Money as an alternative to paper money” Wesleyan Journal of Research, 2020; 13(3): 110-118.</li><li>3. Chadurvedi, M., Pathak D. V., Sanehi, R., Dagar, H., Singh, S., and Saraswati, “Chrysanthemum” (Presented in National Conference in MVN University, ISBN: 978-93-92953-67-5</li>          ",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "N/A",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},

        {img:'/assets/img/SBMC/vikram_manchanda.png',name:'Dr. Vikram Manchanda',position:'Associate Professor',email:'vikram.manchanda@mvn.edu.in', gs: "#",
        linkedin: "https://www.linkedin.com/in/vikm ",
        orcid: "https://orcid.org/0009-0002-1391-9588  ",
        rg: "https://www.researchgate.net/profile/Vikram-Manchanda-2",
        website: "#",
        aoi: " Marketing, Healthtech, FinTech, Strategy ",
        education: "B.E. (E&C), MBA, Ph.D.",
        re: "8",
        te: "4.5",
        iece: "23",
        articles:
          "1. Information Technology in Healthcare in India: A Bibliometric Analysis.",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "1. Best Research Award in MBA.",
        aa2: "2. Topper in Strategic Management in MBA.",
        aa3: "3. Distinction holder in Ph.D. Course work.",
        aa4: "4. Trained in “Six Thinking Hats Technique” by Dr. Edward de Bono.",
        aa5: "5. Consultant to various startups in the area of Healthcare and Martech.  ",
        aa6: "",},

        

        {img:'/assets/img/SBMC/rahul_mongia.png',name:'Dr. Rahul Mongia',position:'Assistant Professor',email:'rahul.mongia@mvn.edu.in', gs: "https://shorturl.at/vPS06",
        linkedin: "https://www.linkedin.com/feed/",
        orcid: "https://orcid.org/0000-0003-0186-4241 orcid",
        rg: "https://www.researchgate.net/profile/Rahul-Mongia",
        website: "#",
        aoi: "Finance, Direct Tax",
        education: "B.Com., MBA (Finance), Ph.D. (Management) & Pursuing CA final",
        re: "5",
        te: "6+",
        iece: "5",
        articles:
          "<li>Google Scholar E- ISSN: 2583-3049 3.Mongia, R., & Singh, N. P. (2025). Indirect tax revenue in the era of GST: A case of Haryana. Technoarete Journal on Taxation and Public Finance, 2(2), 12–20. Indexed: Google Scholar E-ISSN: 2583-4649</li>",
        books:
          "Indexed in : Springer",
        chapters:
          "<LI>1. Mongia, R., & Singh, N. P. (2025). GST and sustainability: An analysis of the Goods and Services Tax in promoting sustainable development. In R. Sindhwani et al. (Eds.), Proceedings of the Sustainability in Emerging Economies – Integrating Business Excellence in Management Education (SEE-IBEME-2024) (pp. 376-385). Advances in Economics, Business and Management Research, 324. https://doi.org/10.2991/978-94-6463-696-3_23</LI>",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "1. Distinction in Advance Accounting in Both group of CA Intermediate.",
        aa2: "2. Distinction Holder in MBA program.",
        aa3: "3. Distinction holder in Ph.D. Course work.",
        aa4: "4. Completed more than 12 short term courses from University of London.",
        aa5: "5. Completed 3 years practical training from reputed CA firm. (East Delhi)",
        aa6: "6. Certified IT trainer from ICAI. ",
        aa7:"7. Been the Track Chairperson of Finance & Accounts session in an international conference on “Campus to Corporate: Industry 4.0",
        aa8:"8. Worked as Team Member in Various Audits of PSUs in India.  ",
        aa9:"9. Awarded as Best Employee in A.N. Khurana and Co.",},

        

       

        
       

        
    ]
return(
    <Grid container spacing={2} sx={{margin:'10px 0px'}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
            <MainTitle title='School of Business Management & Commerce Faculties'/>
        </Grid>
        {facultyList?.map((fac)=>(
        <Grid item xs={12} sm={12} md={4} lg={4}>
            <FacultyCard faculty={fac} />
        </Grid>
        ))}
    </Grid>
)
}
export default FacultyList;